import $ from 'jquery';
import 'arrive';

$(document).ready(function() {
    document.arrive('.block-fullwidth-banner-foldable', {existing: true}, function () {
        intFoldableBanner($(this));
    });
});

function intFoldableBanner($banner) {
    let $container = $banner.find('.block-fullwidth-banner-foldable-content-container');
    let $btn_collapse = $banner.find('.btn-collapse');
    let $video = $banner.find('video.wp-video-shortcode');
    $btn_collapse.click(function (e) {
        if ($video.length) {
            if ($container.hasClass('srg-closed')) {
                //if opening pause video
                $video[0].pause();
            } else {
                // $video[0].play();
            }
        }
        $container.toggleClass('srg-open srg-closed');
        $container.toggleClass('srg-open-mobile srg-closed-mobile');
        e.stopPropagation();
    })
    if ($banner.find('.wp-video-shortcode').length) {
        $banner.find('.srg-desktop-image-container').click(function () {
            $container.removeClass('srg-open').addClass('srg-closed');
        });
    }
    $container.click(function () {
        $btn_collapse.click();
    });
}

function fixMobileSectionsFp() {
    if ($(window).width() < 992) {
        if ($(window).width() >= 768) {
            let $fwf_banners = $('.block-fullwidth-banner-foldable');
            let count_fwf_banners = $fwf_banners.length;
            if (count_fwf_banners > 1) {
                for (let i = 1; i <= count_fwf_banners; i++) {
                    if (!(i % 2)) {
                        $fwf_banners.slice((i - 2), 2).removeClass('section fp-auto-height').wrapAll('<section class="section fp-auto-height"></section>');
                        intFoldableBanner($($fwf_banners[i-2]));
                        intFoldableBanner($($fwf_banners[i-1]));
                    } else if (i === count_fwf_banners) {
                        let $last_fwf_banner = $($fwf_banners[i - 1]);
                        if ($last_fwf_banner.hasClass('last')) {
                            $last_fwf_banner.removeClass('section fp-auto-height');
                        } else {
                            let $next = $last_fwf_banner.next();
                            if ($next.hasClass('block-fullwidth-banner-cta')) {
                                $last_fwf_banner.add($next).removeClass('section fp-auto-height').wrapAll('<section class="section fp-auto-height"></section>');
                            }
                        }
                    }
                }
            }
        }
    }
}

export default {
    fixMobileSectionsFp
}